/* eslint-disable sort-keys */
/* eslint-disable perfectionist/sort-objects */
const lolite = {
  __private: {
    arrayOfAllBooleans: require("./private/arrayOfAllBooleans"),
    crash: require("./private/crash"),
    date: require("./private/date"),
    invertFallback: require("./private/invertFallback"),
    isNotInteger: require("./private/isNotInteger"),
    multiplyFallback: require("./private/multiplyFallback")
  },
  compact: require("./lib/compact"),
  flatten: require("./lib/flatten"),
  first: require("./lib/first"),
  head: require("./lib/first"),
  last: require("./lib/last"),
  tail: require("./lib/tail"),
  initial: require("./lib/initial"),
  sample: require("./lib/sample"),
  times: require("./lib/times"),

  add: require("./lib/add"),
  subtract: require("./lib/subtract"),
  multiply: require("./lib/multiply"),
  divide: require("./lib/divide"),
  invert: require("./lib/invert"),
  abs: require("./lib/abs"),
  sign: require("./lib/sign"),
  power: require("./lib/power"),
  modulo: require("./lib/modulo"),
  floor: require("./lib/floor"),
  ceil: require("./lib/ceil"),
  round: require("./lib/round"),
  trunc: require("./lib/trunc"),
  max: require("./lib/max"),
  min: require("./lib/min"),
  clamp: require("./lib/clamp"),

  and: require("./lib/and"),
  or: require("./lib/or"),
  not: require("./lib/not"),
  nand: require("./lib/nand"),
  nor: require("./lib/nor"),
  xor: require("./lib/xor"),
  xnor: require("./lib/xnor"),

  isTruthy: require("./lib/isTruthy"),
  isFalsy: require("./lib/isFalsy"),

  isUndefined: require("./lib/isUndefined"),
  isNull: require("./lib/isNull"),
  isNil: require("./lib/isNil"),
  isBoolean: require("./lib/isBoolean"),
  isNumber: require("./lib/isNumber"),
  isBigInt: require("./lib/isBigInt"),
  isString: require("./lib/isString"),
  isSymbol: require("./lib/isSymbol"),
  isPrimitive: require("./lib/isPrimitive"),

  isObject: require("./lib/isObject"),
  isFunction: require("./lib/isFunction"),
  isArray: require("./lib/isArray"),
  isMap: require("./lib/isMap"),
  isWeakMap: require("./lib/isWeakMap"),
  isSet: require("./lib/isSet"),
  isWeakSet: require("./lib/isWeakSet"),
  isPlainObject: require("./lib/isPlainObject"),
  isNonNullObject: require("./lib/isNonNullObject"),
  isNaN: require("./lib/isNaN"),
  isFinite: require("./lib/isFinite"),
  isInteger: require("./lib/isInteger"),
  isSafeInteger: require("./lib/isSafeInteger"),
  isArguments: require("./lib/isArguments"),
  
  noop: require("./lib/noop"),
  identity: require("./lib/identity"),
  constant: require("./lib/constant"),
  stubUndefined: require("./lib/stubUndefined"),
  stubNull: require("./lib/stubNull"),
  stubTrue: require("./lib/stubTrue"),
  stubFalse: require("./lib/stubFalse"),
  stubNaN: require("./lib/stubNaN"),

  now: require("./lib/now")
}

module.exports = lolite